module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0024.9eb91bb3.jpg";